<template>
  <div class="home">
    <div >
      <navBar></navBar>
    </div>
<!--    <div id="nav" class="nav col-sm-12 sm-hide ">-->
<!--      <nav></nav>-->
    <!--div class="nav-body">
        <el-menu
            style="display: flex;justify-content: space-around;align-items: center;
            color: #fff;font-size: 18px;"
            :default-active="$route.path"
            class="el-menu-demo sm-font"
            mode="horizontal"
            @select="handleSelect"
            background-color="#2A82E4FF"
            text-color="#fff"
            active-text-color="#fff">
          <el-menu-item index="/">首页</el-menu-item>
          <el-submenu index="/resourceBase">
            <template slot="title">资源</template>
            <el-submenu index="/resourceBase/germplasm">
              <template slot="title">种质资源</template>
              <el-menu-item index="/resourceBase/germplasm/seed">种子</el-menu-item>
              <el-menu-item index="/resourceBase/germplasm/dna">DNA</el-menu-item>
              <el-menu-item index="/resourceBase/germplasm/driedLeaf">干燥叶片</el-menu-item>
              <el-menu-item index="/resourceBase/germplasm/germplasmAnimal">动物种质</el-menu-item>
            </el-submenu>
            <el-submenu index="/resourceBase/dnaBar">
              <template slot="title">DNA条形码</template>
              <el-menu-item index="/resourceBase/dnaBar/spineAnimal">脊椎动物</el-menu-item>
              <el-menu-item index="/resourceBase/dnaBar/vascularPlant">维管植物 (植物)</el-menu-item>
            </el-submenu>
            <el-submenu index="/resourceBase/list">
              <template slot="title">名录</template>
              <el-menu-item index="/resourceBase/list/protectList">高黎贡山国家重点保护野生植物名录</el-menu-item>
              <el-menu-item index="/resourceBase/list/uniqueList">高黎贡山特有植物名录</el-menu-item>
            </el-submenu>
            <el-submenu index="/resourceBase/workGuide">
              <template slot="title">工作指南</template>
              <el-menu-item index="/resourceBase/workGuide/management">种质资源采集和管理规范</el-menu-item>
              <el-menu-item index="/resourceBase/workGuide/filling">野外数据填写规范 (植物)</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="/dynamic">
            <template slot="title">动态</template>
            <el-menu-item index="/dynamic/information">动态资讯</el-menu-item>
            <el-menu-item index="/dynamic/progressWork">工作进展</el-menu-item>
          </el-submenu>
          <el-submenu index="/scientificResearch">
            <template slot="title">科考影像</template>
            <el-menu-item index="/scientificResearch/picture">图片</el-menu-item>
            <el-menu-item index="/scientificResearch/video">视频</el-menu-item>
          </el-submenu>
          <el-submenu index="/help">
            <template slot="title">帮助</template>
            <el-menu-item index="/help/problem">常见问题</el-menu-item>
            <el-menu-item index="/help/relationWe">联系我们</el-menu-item>
          </el-submenu>
        </el-menu>
      </div-->
<!--    </div>-->
    <div class="swiper">
      <div class="col col-xlg-12  col-lg-12 col-sm-12 swiper-item">
        <el-carousel :interval="3000" arrow="always">
          <el-carousel-item v-for="item in swiperList" :key="item.id">
            <img style="object-fit: cover" :src="item.url"  class="swiper-img">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
<!--   弹性布局  动态资讯-->
    <div class="main-row contain">
      <div class="col col-xlg-12 col-lg-12 col-sm-12 title" style="font-size: 24px;font-weight: 400">
          <h2 class="front-block-title">动态资讯</h2>
          <div class="front-block-subtitle">Information</div>
      </div>
    </div>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-12 information">
        <div class="tit">
          <div :class="num==1?'active':''" @click="num=1">动态资讯</div>
          <div :class="num==2?'active':''" @click="num=2">工作进展</div>
        </div>
        <div class="main-row" v-if="num==1">
          <div class="col col-xlg-6 col-lg-6 col-md-6 col-sm-12 information">
            <div @click="toDynamicInfo(editorInfoImg)" class="img">
              <img  :src="this.firstImg" alt="" >
              <div class="inforTit">{{this.editorInfoImg.title}}</div>
            </div>
          </div>
          <div class="col col-xlg-6 col-lg-6 col-md-6 col-sm-12 information">
            <div class="ul"  v-for="(item, index) in informationList" :key="informationList[index].id"
                 @click="toDynamic(item)" :class="{active:dataTag==index}">
              <span class="content">{{item.title}}</span><span class="date">{{item.createTime}}</span>
            </div>
            <div class="more" @click="toDynamicList"><i class="el-icon-d-arrow-right"></i>查看更多</div>
          </div>
        </div>
        <div class="main-row" v-if="num==2">
<!--          editorProcessImg-->
          <div class="col col-xlg-6 col-lg-12 col-md-12 col-sm-12 process">
            <div @click="toDynamicPro(editorProcessImg)" class="img">
              <img  :src="this.firstImgProgress" alt="" style="object-fit: cover !important;">
              <div class="inforTit">{{this.editorProcessImg.title}}</div>
            </div>
            <!--
            <div @click="toDynamicPro(editorProcessImg[i])" class="img"
                 v-for="(pro,i) in editorProcessImg" v-if="dataTag==i">
              <img :src="pro.capture" alt="" >
              <div class="inforTit">{{pro.title}}</div>

            </div>
            -->
          </div>
          <div class="col col-xlg-6 col-lg-12 col-md-6 col-sm-12 process">
            <div class="ul"  v-for="(p, index) in processList" :key="processList[index].id"
                 @click="toDynamicTitle(p)" :class="{active:dataTag==index}">
              <span class="content">{{p.title}}</span><span class="date">{{p.createTime}}</span>
            </div>
            <div class="more" @click="toDynamicProList"><i class="el-icon-d-arrow-right"></i>查看更多</div>
          </div>
        </div>
      </div>
    </div>
<!--    野生植物资源库-->
    <div class="main-row contain">
      <div class="col col-xlg-12 col-lg-12 col-sm-12 title" style="font-size: 20px;">
        野生植物资源库
<!--        <p>WILD PLANT GERMPLASM BANK</p>-->
        <p>Catalogue of Germplasm Resources</p>
      </div>
    </div>
    <!--<div class="main-row contain">
      <div class="col col-xlg-4 col-lg-4 col-md-6 col-sm-12 wild "
           @click="toResoureBase('seed')">
        <img :src="this.pictureSeeds" alt="">
        <div class="text"><span>种子</span></div>
      </div>
      <div class="col col-xlg-4 col-lg-4 col-md-6 col-sm-12 wild "
           @click="toResoureBase('dna')">
        <img :src="this.pictureDna" alt="">
        <div class="text"><span>DNA</span></div>
      </div>
      <div class="col col-xlg-4 col-lg-4 col-md-6 col-sm-12 wild "
           @click="toResoureBase('driedLeaf')">
        <img :src="this.pictureDriedLeaf" alt="">
        <div class="text"><span>干燥叶片</span></div>
      </div>
      <div class="col col-xlg-4 col-lg-4 col-md-6 col-sm-12 wild "
           @click="toResoureBase('germplasmAnimal')">
        <img :src="this.pictureAnimalgermplasm" alt="">
        <div class="text"><span>动物种质</span></div>
      </div>
      <div class="col col-xlg-4 col-lg-4 col-md-6 col-sm-12 wild wild-list "
           @click="toResoureBase('spineAnimal')">
        <img :src="this.pictureSpineAnimal" alt="">
        <div class="text"><span>脊椎动物</span></div>
      </div>
      <div class="col col-xlg-4 col-lg-4 col-md-6 col-sm-12 wild  wild-list"
           @click="toResoureBase('vascularPlant')">
        <img :src="this.pictureVascularPlant" alt="">
        <div class="text"><span>维管植物</span></div>
      </div>
    </div> -->
    <div class="main-row contain resources" style="margin: 0 auto;display: flex;justify-content: space-between;">
      <div class="col-xlg-2 col-lg-2 col-md-2 col-sm-2 col-12 resources-item"  @click="toResoureBase('seed')">
        <img :src="pictureSeeds" alt="" >
        <div  class="resources-title">种子</div>
      </div>
      <div class="col-xlg-2 col-lg-2 col-md-2 col-sm-2 col-12 resources-item"  @click="toResoureBase('seed')">
        <img :src="pictureDna" alt=""  >
        <div  class="resources-title">非种子植物种质</div>
      </div>
      <div class="col-xlg-2 col-lg-2 col-md-2 col-sm-2 col-12 resources-item" @click="toResoureBase('germplasmAnimal')">
        <img :src="pictureAnimalgermplasm" alt="" style="">
        <div class="resources-title">动物种质</div>
      </div>
      <div class="col-xlg-2 col-lg-2 col-md-2 col-sm-2 col-12 resources-item"  @click="toResoureBase('vascularPlant')">
        <img :src="pictureVascularPlant" alt="" >
        <div  class="resources-title">植物DNA条形码</div>
      </div>
      <div class="col-xlg-2 col-lg-2 col-md-2 col-sm-2 col-12 resources-item" @click="toResoureBase('spineAnimal')">
        <img :src="pictureSpineAnimal" alt="" >
        <div  class="resources-title">动物DNA条形码</div>
      </div>

<!--    <div style="width: 100%;display: flex" v-for="item in 5">-->

<!--      <div>{{item}}</div>-->
<!--      <div style="width: 20%;border: 1px solid red;height: 500px">-->
<!--        <img src="/img/动物DNA条形码.jpg" alt="" style="width: auto; height: 500px;overflow: hidden">-->
<!--      </div>-->
<!--      <div style="width: 20%;border: 1px solid red;height: 500px">-->
<!--        <img src="/img/种子.jpg" alt="" style="width: auto; height: 500px;overflow: hidden">-->
<!--      </div>-->
<!--      <div style="width: 20%;">1df</div>-->
<!--      <div style="width: 20%;">1df</div>-->
<!--      <div style="width: 20%;">1df</div>-->
<!--    </div>-->
    </div>
    <div class="main-row contain">

    </div>
<!--   科考影像 -->
    <div class="main-row contain">
      <div class="col col-xlg-12 col-lg-12 col-sm-12 title" style="font-size: 20px;">
        科考影像
<!--        <p>SCIENTIFIC RESEARCH IMAGE</p>-->
        <p>Expeditions Gallery</p>
      </div>
    </div>
    <div class="main-row contain">
      <div class="col col-xlg-6 col-lg-6  col-sm-12 scientific">
        <div class="left-img">
          <img style="object-fit: cover" v-if="this.showVideo.pictureVideoFileList" class="" :src="this.showVideo.pictureVideoFileList[0].url" alt="">
        </div>
      </div>
      <div class="col col-xlg-6 col-lg-6 col-sm-12 scientific">
          <div class="scientific-content">
            <p class="line">▂▂▂▂▂▂▂</p>
            <h3 style="font-size: 16px">{{ this.showVideo.title }}</h3>
            <div class="text">{{ this.editorText }}</div>
            <div class="scientific-img">
              <div class="scientific-bottom" v-for="item in this.scientificSmallPic">
<!--                {{item}}-->
<!--                <img class="img" v-for="img in item.pictureVideoFileList" :src="img.url" alt="">-->
                <img style="object-fit: cover" v-if="!isContentImg" class="img"  :src="item.url" alt="" >
<!--                <img  class="img"  :src="item" alt="">-->
                <img style="object-fit: cover" v-else class="img"  :src="item" alt="">
              </div>
            </div>
            <div class="more" @click="toScientific">
              <i class="el-icon-d-arrow-right"></i>查看更多</div>
          </div>
      </div>

    </div>
<!--   项目合作单位 -->
    <div class="main-row contain">
      <div class="col col-xlg-12 col-lg-12 col-sm-12 title" style="font-size: 20px;">
        项目合作单位
<!--        <p>PROJECT PARTNER UNIT</p>-->
        <p>Project Partner</p>
      </div>
    </div>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-lg-12 col-sm-12 project">
        <div v-for="item in logoList" :key="item.id" @click="toLink(item.url)">
          <img class="img" v-for=" proj in item.cooperativeUnitFileList" :key="proj.id"
               :src="proj.url" alt="">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import navBar from '@/components/navBar/homeNav'
import { cooperativeunit } from '@/network/cooperativeunit'
import {fetchList} from "@/network/dynamic/information";
import {information, progressWorkInfo,pictureVideoInfo, getDynamicHomeImg} from "@/network/detailCom";
import {getResourceBasePicture} from '@/network/home'
// import nav from '@/components/nav/nav'
export default {
  name: 'Home',
  components: {  navBar },
  data() {
    return {
      type:'information',
      proType: 'progressWork',
      videoType: 'picture',
      page: 1,
      pageSize: 7,
      totalPage: 10,
      activeName:'information',
      swiperList: [],
      logoList: [],
      informationTit: ['动态资讯','工作进展'],
      informationList:[],
      processList: [],
      num: 1,
      dataTag: 0,
      pictureSeeds:'',
      pictureAnimalgermplasm:'',
      pictureCollectManagement:'',
      pictureDna:'',
      pictureDriedLeaf:'',
      pictureFieldData:'',
      pictureSpineAnimal:'',
      pictureVascularPlant:'',
      videoList:[],
      showVideo: {},
      editorText: '',
      // editorImg: [],
      scientificSmallPic: [],
      scientificDefault: [
        {id: 0,url: '/scientific/scientific1.png'},
        {id: 1,url: '/scientific/scientific2.png'},
        {id: 2,url: '/scientific/scientific3.png'},
      ],
      isContentImg: false,
      certification: '',//实名认证否？
      token: '',
      informationContent: '',
      informationImg: [],
     editorProcessImg: {},//工作进展图片列表
      editorImg: [],
      editorInfoImg: {},
      firstImg: '',
      // firstImg: {},
      firstImgProgress: ''

    }
  },
  mounted() {
    this.certification  = JSON.parse(localStorage.getItem('certification'))
    this.token   = localStorage.getItem('access_token');
    this.getInformation()
    this.getProgressWork()
    this.getResourceBase()
    this.getVideoInfo()
    this.getLogoList()

  },
  methods: {
    changeTab(val) {
      this.num = val
    },
    getInformation() {
      information(Object.assign({
          current: this.page,
          size: this.pageSize,
          type: this.type
        })).then(response => {
        // console.log(response)
          this.informationList = response.data.data.records
          this.totalPage = response.data.data.total
        /*  this.informationList.forEach(item => {
            if (item.content.includes('<img')) {
              item.content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, (match, capture) => {
                let id = item.id
                let type = item.type
                let title = item.title
                this.editorImg.push({capture,id,type, title})
                const [first] = this.editorImg;
                this.firstImg = first
                // console.log(this.firstImg)
                return this.editorImg
              })
            }
          })*/
        })
      getDynamicHomeImg({type: 'information'}).then(res => {
        // console.log('getDynamicHomeImg',res)
        if(res.data.code == 0) {
          this.editorInfoImg = res.data.data
          this.firstImg = res.data.data.imgSrc[0]
          // console.log('img',res.data.data.imgSrc[0])
        }
      })
      },
    getProgressWork() {
      progressWorkInfo(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: this.proType
      })).then(response => {
        this.processList = response.data.data.records
        this.totalPage = response.data.data.total
       /* this.processList.forEach(item => {
          if (item.content.includes('<img')) {
            item.content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, (match, capture) => {
              let id = item.id
              let type = item.type
              let title = item.title
              this.editorProcessImg.push({capture,id,type, title})
              const [first] = this.editorProcessImg;
              this.firstImgProgress = first
              return this.editorProcessImg
            })
          }
        })*/

      })
      getDynamicHomeImg({type: 'progressWork'}).then(res => {
        // console.log('progressWork',res)
        if(res.data.code == 0) {
          this.editorProcessImg = res.data.data
          this.firstImgProgress = res.data.data.imgSrc[0]
        }
      })
    },
    getResourceBase(){
      getResourceBasePicture().then(res => {
        // console.log('getResourceBasePicture',res)
        this.swiperList = res.data.data.shufflingPictureList
       this.pictureSeeds = res.data.data.pictureSeeds.url //种子
       this.pictureAnimalgermplasm = res.data.data.pictureAnimalgermplasm.url //动物种质
       this.pictureCollectManagement = res.data.data.pictureCollectManagement.url
       this.pictureDna = res.data.data.pictureDna.url //非种子植物种质
       this.pictureDriedLeaf = res.data.data.pictureDriedLeaf.url
       this.pictureFieldData = res.data.data.pictureFieldData.url
       this.pictureSpineAnimal = res.data.data.pictureSpineAnimal.url //动物DNA条形码
       this.pictureVascularPlant = res.data.data.pictureVascularPlant.url //植物DNA条形码
      })
    },
    //科考影像
    getVideoInfo() {
        pictureVideoInfo(Object.assign({
          current: this.page,
          size: 1,
          type: this.videoType
        })).then(response => {
          // console.log(response)
          this.videoList = response.data.data.records
          this.getEditorText(this.videoList[0].content)
          this.fn(this.videoList[0].content)
          this.showVideo = this.videoList[0]
          if(this.videoList[0].content.includes('<img')) {
            this.isContentImg = true
            // console.log(this.videoList[0].content)
            this.videoList[0].content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
              // console.log(capture)
              this.scientificSmallPic.push(capture)
              // console.log('scientificSmallPic',this.scientificSmallPic)
              if(this.scientificSmallPic.length >3) {
                this.scientificSmallPic = this.scientificSmallPic.slice(0,3)
              }
              return this.scientificSmallPic
            })
          } else {
            this.isContentImg = false
            this.scientificSmallPic = this.scientificDefault

          }
           // this.scientificSmallPic = this.videoList.slice(0,3)
          this.totalPage = response.data.data.total
        })
    },
    //植物资源库
    toResoureBase(val) {
      if(this.certification === '2' && this.token) {
        if(val === 'protectList') {
          this.$router.push('/resourceBase/list/protectList')
        }else if(val === 'uniqueList') {
          this.$router.push('/resourceBase/list/uniqueList')
        }else if(val === 'seed') {
          this.$router.push('/resourceBase/germplasm/seed')
        }else if(val === 'dna') {
          this.$router.push('/resourceBase/germplasm/dna')
        }else if(val === 'driedLeaf') {
          this.$router.push('/resourceBase/germplasm/driedLeaf')
        }else if(val === 'germplasmAnimal') {
          this.$router.push('/resourceBase/germplasm/germplasmAnimal')
        }else if(val === 'management') {
          this.$router.push('/resourceBase/workGuide/management')
        }else if(val === 'filling') {
          this.$router.push('/resourceBase/workGuide/filling')
        }else if(val === 'spineAnimal') {
          this.$router.push('/resourceBase/dnaBar/spineAnimal')
        }else if(val === 'vascularPlant') {
          this.$router.push('/resourceBase/dnaBar/vascularPlant')
        }
      }else if(!this.token){
        this.$message.error('你还未登录，请先登录')
      }else if(this.token && this.certification !== '2') {
        this.$message.error('你还未实名认证，无权查看该内容,请先实名认证！')
      }

    },
    //去动态资讯列表页
    toDynamicList() {
      this.$router.push('/dynamic/information')
    },
    //去动态资讯详情
    toDynamicInfo(item) {
      // console.log('item122',item)
      if(this.token) {
        this.$router.push('/detail/'+ item.id + '/' + item.type)
      }else {
        this.$message.error('你还未登录，请先登录！')
      }
      // console.log('info', item)
    },
    //标题去动态资讯详情
    toDynamic(item) {
      if(this.token) {
        this.$router.push('/detail/'+ item.id + '/' + item.type)
      }else {
        this.$message.error('你还未登录，请先登录！')
      }
      // console.log('info', item)
    },
    toDynamicProList() {
      this.$router.push('/dynamic/progressWork')
    },
    //去工作进展详情
    toDynamicPro(item){
      if(this.token) {
        this.$router.push('/detail/' + item.id + '/' + item.type)
      }else  {
        this.$message.error('你还未登录，请先登录！')
      }
    },
    toDynamicTitle(item) {
      if(this.token) {
        this.$router.push('/detail/' + item.id + '/' + item.type)
      }else  {
        this.$message.error('你还未登录，请先登录！')
      }
    },
    //去工作进展详情
    toProcessWork(id,index){

    },
    //科考影像查看更多
    toScientific() {
      if(this.token && this.certification == '2') {
        this.$router.push('/scientificResearch/picture')
      } else if(!this.token) {
        this.$message.error('还未登录，请先登录！')
      }else if(this.token && this.certification !=='2') {
        this.$message.error('你还未实名认证，请先实名认证！')
      }
    },
    getLogoList() {
      cooperativeunit().then(res => {
        this.logoList = res.data.data.records
        this.logoList =  res.data.data.records.slice(0,5)
        // console.log(this.logoList)
      })
    },
    //去项目合作单位的链接
    toLink(link) {
      // console.log(123,link)
      window.open(link,'_blank')
    },
    getEditorText(str){
      this.editorText = str.replace(/<[^>]+>/g, "")
      return this.editorText
    },
    fn(str) {
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
        this.editorImg.push(capture)
      })
      return  this.editorImg
    },
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },

  }

}
</script>
<style  lang="scss">

@import "../assets/css/media.css";
@import "../assets/css/home.scss";
</style>
